import Head from 'next/head';
import { Navbar, Sidebar } from '../navigation';
import container from '@/_shared/services/service-container';
import { IdentityService } from '@/_shared/services';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import Loader from '../loaders/loader.component';
import { authBrowserStorage } from '@/_shared/utils/browser-storage.utils';
import {
  register429Handler,
  setupAxiosInterceptor,
} from '@/_shared/services/axios-client';
import ConnectionError from '../pages/ConnectionError';

interface ScaffoldProps {
  children: React.ReactNode;
}

const Scaffold = ({ children }: ScaffoldProps) => {
  const identityService = container.get<IdentityService>('IdentityService');
  const [verifyingSession, setVerifyingSession] = useState(true);

  const router = useRouter();
  const { data: session, status } = useSession();

  useEffect(() => {
    if (session) {
      authBrowserStorage.setOnboarded(session.user.onboarded);
    }

    if (session?.user.consent === 'false') {
      router.push(`/accept-terms-of-use?user=${session.user.id}`);
    }

    if (status === 'unauthenticated') {
      identityService.logout();
      router.push('/');
    }
  }, [router, status, session, identityService]);

  useEffect(() => {
    if (session?.user?.bearer) {
      setupAxiosInterceptor(session.user.bearer);
      setVerifyingSession(false);
    }
  }, [session]);

  const [rateLimited, setRateLimited] = useState(false);

  useEffect(() => {
    register429Handler(() => setRateLimited(true));
  }, []);

  useEffect(() => {
    register429Handler(() => setRateLimited(true));
  }, []);

  return (
    <>
      <Head>
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <main className="h-dvh overflow-hidden">
        {verifyingSession && (
          <div className="w-full min-h-screen flex items-center justify-center overflow-hidden">
            <Loader />
          </div>
        )}

        {!verifyingSession && (
          <div className="flex h-full min-h-0 overflow-hidden bg-background-gray">
            <Sidebar />
            <div className="flex min-h-0 flex-col grow overflow-y-auto">
              <Navbar />
              <div className="mt-[106px] lg:mt-16" />
              {rateLimited ? <ConnectionError /> : children}
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Scaffold;
